const bands = [
  {
    name: "Band 1",
    handle: "stack-builder-band-1",
    key: "band1",
    price: 95,
    image: "Band_1_NBG.png",
  },
  {
    name: "Band 2",
    handle: "stack-builder-band-2",
    key: "band2",
    price: 75,
    image: "Band_2_NBG.png",
  },
  {
    name: "Band 3",
    handle: "stack-builder-band-3",
    key: "band3",
    price: 65,
    image: "Band_3_NBG.png",
  },
  {
    name: "Band 4",
    handle: "stack-builder-band-4",
  
    price: 120,
    image: "Band_4_NBG.png",
  },
  {
    name: "Band 5",
    handle: "stack-builder-band-5",
    
    price: 85,
    image: "Band_5_NBG.png",
  },
];

const positions = ["Top", "Middle", "Bottom"];

const initialSelections = {
  Top: 0,
  Middle: 1,
  Bottom: 2,
};

const initialSize = "7";

const selections = { ...initialSelections };
let selectedSize = initialSize;

const selectorsElement = document.getElementById("selectors");
const selectedListElement = document.getElementById("selected-list");
const totalPriceElement = document.getElementById("total-price");
const addStackButton = document.getElementById("add-stack");
const resetStackButton = document.getElementById("reset-stack");
const ringSizeSelect = document.getElementById("ring-size");

function formatPrice(price) {
  return `$${price}`;
}

function getImagePath(image) {
  return `/cdn/shop/files/${image}`;
}

function cycleBand(position, direction) {
  const currentIndex = selections[position];
  const nextIndex = (currentIndex + direction + bands.length) % bands.length;

  selections[position] = nextIndex;
  render();
}

function createPositionControl(position) {
  const article = document.createElement("article");
  article.className = "position-control";

  article.innerHTML = `
    <p class="position-label">${position}</p>
    <div class="selector-row">
      <button type="button" class="arrow-button" data-direction="-1" aria-label="Previous ${position} band">&lsaquo;</button>
      <div class="band-image-wrap">
        <img data-role="selector-image" alt="">
      </div>
      <button type="button" class="arrow-button" data-direction="1" aria-label="Next ${position} band">&rsaquo;</button>
    </div>
    <div class="band-details">
      <p class="band-name" data-role="selector-name"></p>
      <p class="band-price" data-role="selector-price"></p>
    </div>
  `;

  article.querySelectorAll(".arrow-button").forEach((button) => {
    button.addEventListener("click", () => {
      console.log("Arrow clicked:", position, button.dataset.direction);
cycleBand(position, Number(button.dataset.direction));
    });
  });

  return article;
}

function renderSelectors() {
  positions.forEach((position) => {
    const control = document.querySelector(`[data-position="${position}"]`);
    const band = bands[selections[position]];
    const image = control.querySelector('[data-role="selector-image"]');

    image.src = getImagePath(band.image);
    image.alt = `${position} selected band: ${band.name}`;
    control.querySelector('[data-role="selector-name"]').textContent = band.name;
    control.querySelector('[data-role="selector-price"]').textContent =
      formatPrice(band.price);
  });
}

function renderPreview() {
  positions.forEach((position) => {
    const band = bands[selections[position]];
    const image = document.getElementById(`preview-${position.toLowerCase()}`);

    image.src = getImagePath(band.image);
    image.alt = `${position} preview: ${band.name}`;
  });
}

function renderSummary() {
  selectedListElement.innerHTML = "";

  const sizeItem = document.createElement("li");
  sizeItem.dataset.summaryLabel = "Ring Size";
  sizeItem.innerHTML = `
    <span>Size</span>
    <strong>${selectedSize}</strong>
  `;
  selectedListElement.appendChild(sizeItem);

  const total = positions.reduce((sum, position) => {
    const band = bands[selections[position]];
    const item = document.createElement("li");
    item.dataset.summaryLabel = `${position} Ring`;

    item.innerHTML = `
      <span>${band.name}</span>
      <strong>${formatPrice(band.price)}</strong>
    `;

    selectedListElement.appendChild(item);
    return sum + band.price;
  }, 0);

  totalPriceElement.textContent = formatPrice(total);
}

function render() {
  ringSizeSelect.value = selectedSize;
  renderSelectors();
  renderPreview();
  renderSummary();
}

function resetStack() {
  positions.forEach((position) => {
    selections[position] = initialSelections[position];
  });

  selectedSize = initialSize;
  render();
}

function getSelectedStack() {
  const selectedBands = positions.map((position) => {
    const band = bands[selections[position]];

    return {
  position,
  key: band.key,
  name: band.name,
  price: band.price,
  image: band.image,
};
  });

  const totalPrice = selectedBands.reduce((sum, band) => sum + band.price, 0);

  return {
    size: selectedSize,
    bands: selectedBands,
    totalPrice,
  };
}

positions.forEach((position) => {
  const control = createPositionControl(position);
  control.dataset.position = position;
  selectorsElement.appendChild(control);
});
async function getVariantForBandAndSize(band, size) {
  const response = await fetch(`/products/${band.handle}.js`);
  console.log(band.handle, response.status);

  const product = await response.json();

  const variant = product.variants.find(item => item.title === size);

  if (!variant) {
    throw new Error(`No variant found for ${band.name} size ${size}`);
  }

  return variant;

}
addStackButton.addEventListener("click", async () => {
addStackButton.disabled = true;
addStackButton.textContent = "Adding...";
  
  const stack = getSelectedStack();

for (const band of [...stack.bands].reverse()) {
  const product = window.revaStackBuilderProducts[band.key];

  const variant = product.variants.find(
    (v) => v.option1 === stack.size
  );

  await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      id: variant.id,
      quantity: 1
    })
  });
}

alert("Stack added to cart. Please check your cart.");
resetStack();
addStackButton.disabled = false;
addStackButton.textContent = "Add Stack";

console.log("Selected Reva stack:", stack);
});
ringSizeSelect.addEventListener("change", () => {
  selectedSize = ringSizeSelect.value;
  render();
});

resetStackButton.addEventListener("click", resetStack);

render();